import { Input, Select } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowRight from '../../assets/images/arrow-rigth.png';
import useGetAllData from '../../hooks/useGetAllData';
import useUrlQueryParams from '../../hooks/useUrlQeryParams';
import { INewCalculator } from '../../models/new_calculator';
import { ICalculatorPrices } from '../../models/calculator_prices';

const MyCalculator: React.FC = () => {
    const { t } = useTranslation();
    const bmx = 375000;
    const [value, setValue] = useState<number | string>('50000000');
    const [typeValue, setTypeValue] = useState<string>('/api/new_calculators/1');
    const [type, setType] = useState<number>(2);
    const [arbitratorShare, setArbitratorShare] = useState<number>(1);

    const { urlValue } = useUrlQueryParams({ currentPage: 1, perPage: 10 });

    const { data: newCalculator } = useGetAllData<INewCalculator[]>({
        queryKey: ['new_calculators', urlValue.perPage, urlValue.currentPage],
        url: 'new_calculators',
        urlParams: { PerPage: urlValue.perPage, page: 1 },
    });

    const { data: calculatorPrice } = useGetAllData<ICalculatorPrices[]>({
        queryKey: ['calculator_prices', urlValue.perPage, urlValue.currentPage, typeValue],
        url: 'calculator_prices',
        urlParams: { PerPage: urlValue.perPage, page: urlValue.currentPage, 'newCalculator.id': typeValue },
        options: { enabled: Boolean(typeValue) },
    });

    // const formatNumber = (num: string) => new Intl.NumberFormat().format(Number(num.replace(/,/g, '')));

    // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setValue(e.target.value.replace(/,/g, ''));
    // };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let rawValue = e.target.value.replace(/\D/g, "");
        if (!rawValue) {
            setValue("");
            return;
        }
        setValue(Number(rawValue));
    };

    const formatNumber = (num: number | string) => {
        if (!num) return "";
        return new Intl.NumberFormat("uz-UZ").format(Number(num));
    };

    const handleChangeType = (value: string) => {
        setTypeValue(value);
    };

    const handleChangeCount = (value: number) => {
        setArbitratorShare(value);
    };

    const resultAmount = calculatorPrice?.flatMap(item => {
        return type === 1 ? item?.amount : type === 2 ? item?.minAmount : item?.maxAmount;
    }).filter(element => element && Number(value) > element.start && Number(value) <= element.end) || [];

    const regestrationFee = resultAmount.length > 0 ? (resultAmount[0]?.bmx ?? 0) * bmx : 0;
    const medetionFee = resultAmount.length > 0 ? (arbitratorShare === 1 ? ((resultAmount[0]?.One_arbitrator ?? 0)/100) * Number(value) : (arbitratorShare === 3 ? (resultAmount[0]?.Three_arbitrator ?? 0) * (Number(value) / 100) : 0)) : 0;

    
    return (
        <div className='border-b-2 border-[#29487E] pb-12'>
            <h2 className='text-[22px] font-bold text-[#17608B] mb-6'>{t('Calculation')}</h2>
            <div className="grid grid-cols-12 sm:gap-4 gap-y-10">
                <div className="lg:col-span-7 sm:col-span-6 col-span-12 grid grid-cols-12 gap-3 sm:border-r-2 border-main_color sm:pr-5">
                    <div className="col-span-12">
                        <Input
                            placeholder={`${t('Enter sum')}`}
                            className='h-[41px]'
                            min={50000000}
                            type="text"
                            value={formatNumber(value)}
                            onChange={handleChange}
                            allowClear
                        />
                    </div>
                    <div className="md:col-span-6 col-span-12">
                        <h3 className='text-main_color mb-2'>{t('Type of arbitration / mediation')}</h3>
                        <Select
                            className='w-full h-[41px]'
                            placeholder='Select arbitrator type'
                            defaultValue={'/api/new_calculators/1'}
                            onChange={handleChangeType}
                        >
                            {newCalculator?.map((newItem:any) => (
                                <Select.Option value={newItem['@id']} key={newItem['@id']}>
                                    <p onClick={() => setType(newItem?.type)}>{newItem?.name}</p>
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className="md:col-span-6 col-span-12">
                        <h3 className='text-main_color mb-2'>{t('Number of arbitrators / mediators')}</h3>
                        <Select
                            className='w-full h-[41px]'
                            placeholder={t('Select arbitrator number')}
                            defaultValue={arbitratorShare}
                            onChange={handleChangeCount}
                            disabled = {type == 3 ? true : false}
                            options={[
                                { value: 1, label: <p>{type == 3 ? "Mediator to'lovi" : '1 ta'}</p> },
                                { value: 3, label: <p>3 ta</p> },
                            ]}
                        />
                    </div>
                </div>
                <div className="lg:col-span-5 sm:col-span-6 col-span-12">
                    <div className='flex justify-between items-center border-b-2 border-[#29487E] pb-2 mb-8'>
                        <span>{t('Registration fee')}</span>
                        <span>{formatNumber(String(regestrationFee))}</span>
                    </div>
                    <div className='flex justify-between items-center border-b-2 border-[#29487E] pb-2 mb-4'>
                        <span>{t('Arbitration | Mediation fee')}</span>
                        <span>{formatNumber(String(medetionFee))}</span>
                    </div>
                    <div className='mt-12'>
                        {t('Total')}
                        <div className='flex justify-between items-center'>
                            <img src={ArrowRight} alt='icon' />
                            <span className='font-bold'>{formatNumber(String(regestrationFee + medetionFee))}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyCalculator;
